DataQueryDefinitionFactory.$inject = [
	'$q',
	'mx.sb.Agent.DataQuery.Column',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.SolutionBuilderAgent.EntityService',
];
export default function DataQueryDefinitionFactory($q, DataQueryColumn, externalServiceManager, schemaService, entityService) {
	/**
	 * @ngdoc Class
	 * @name mx.sb.Agent.DataQuery.DataQueryDefinition
	 *
	 * @description
	 * Class DataQueryDefinition
	 *
	 * @param {Object} options - attributes of data query
	 *
	 */
	function DataQueryDefinition(options) {
		this.filterChangeHandlers = [];

		angular.extend(this, options);

		if (this.Service) {
			this.serviceInfo = externalServiceManager.parseServiceInfo(this.ServiceInfo);
			this.executeOptions = externalServiceManager.getListExecuteOptions(this, mx.SolutionBuilderAgent.SupportedOperations.ReadObjectsByODataQuery, entityService);
		}

		this._debouncedNotifyFilterChanged = $.debounce(1000, () => this._notifyFilterChanged());

		this.initColumns(options);
	}

	DataQueryDefinition.prototype = {
		initColumns: function (options) {
			options.Columns = Array.isArray(options.Columns) ? options.Columns : [];

			this._setKeywordOption(options.Columns);

			this.Columns = options.Columns.map(function (columnDefinition) {
				columnDefinition = angular.copy(columnDefinition);

				if (this.Service) {
					if (
						columnDefinition.ReferenceTo &&
						columnDefinition.AttributeValueType === mx.shell.ObjectPropertyType.Integer.name &&
						this.serviceInfo.Enums[columnDefinition.ReferenceTo]
					) {
						columnDefinition.ReferenceTo = 'service_' + options.Service + '_' + columnDefinition.ReferenceTo;
					}
				}

				const column = new DataQueryColumn(columnDefinition);
				column.filter.addChangeHandler(this._onFilterChange.bind(this));

				return column;
			}, this).sort(function compareNumbers(a, b) {
				return (a.Position || 0) - (b.Position || 0);
			});
		},

		_onFilterChange(filter, urgent) {
			if (this._internalChange) {
				return;
			}
			if (urgent) {
				this._notifyFilterChanged();
			} else {
				this._debouncedNotifyFilterChanged();
			}
		},

		_notifyFilterChanged() {
			const columnWithFilters = this.Columns.filter((column) => column.filter.hasValue());
			const newFilter = columnWithFilters.map((column) => {
				return {
					value: column.filter.value,
					operator: column.filter.operator,
				};
			});

			if (!angular.equals(newFilter, this._previousFilter)) {
				this._previousFilter = newFilter;
				this.filterChangeHandlers.forEach((handler) => handler(columnWithFilters));
			}
		},

		addFilterChangeHandler(handler) {
			if (typeof handler === 'function') {
				this.filterChangeHandlers.push(handler);
			}
		},

		clearAllFilters() {
			this._internalChange = true;
			this.Columns.forEach((column) => column.filter.clearFilter());
			this._internalChange = false;

			this._notifyFilterChanged();
		},

		_setKeywordOption: function (colsDef) {
			var hasKeywordsFields = colsDef.some(function (column) {
				return column.IsKeyword;
			});

			if (!hasKeywordsFields) {
				colsDef.forEach(function (column) {
					column.IsKeyword = column.AttributeValueType === mx.shell.ObjectPropertyType.String.name;
				});
			}
		},

		getColumnByName: function (name) {
			return this.Columns.find(function (it) {
				return it.Name === name;
			});
		},

		getPropertyPath: function (columnName) {
			var path = [];

			var column = this.getColumnByName(columnName);
			if (!column) {
				return path;
			}

			if (column.TargetAttributePaths.length) {
				return column.TargetAttributePaths;
			}

			if (!column.HasQuery) {
				if (!this.Service) {
					path.push(this.SchemaClassName);
				}
				path.push(column.RawValuePropertyName);
			} else if (column.ExpressionType === 'T') {
				path.push(column.ExpressionClassName);
				path.push(column.ExpressionDependencies[0]);
			}

			return path;
		},

		getRecordTypeDisplayString: function () {
			if (this.SchemaClassName) {
				return schemaService.getClassInfo(this.SchemaClassName).then(function (info) {
					return info.DisplayName;
				});
			} else if (this.Service) {
				return this.executeOptions.typeInfo.GetTypeDisplayNamePromise();
			}
			return $q.when();
		},

		//TODO: move to Requester
		isExportSupported: function () {
			var serviceInfoOperationsExists = this.ServiceInfo && this.ServiceInfo.Operations && this.ServiceInfo.Operations.length > 0;
			var operationsExists = this.ServiceInfo.Operations[0];
			if (serviceInfoOperationsExists && operationsExists) {
				return _.get(operationsExists, 'RequestContract.UsedTypes.RequestContract.Descriptor.export.Type', '') === 'BoolType';
			}

			return false;
		},
	};

	return DataQueryDefinition;
}
